<template>
  <div id="login">
    <a-row type="flex" justify="center" align="middle">
      <a-col :span="6">
        <a-card class="login-card">
          <img src="../assets/IO-Controls_Logo.png" alt="I/O Controls Logo" slot="cover" class="io-controls-logo" />
          <a-card-meta>
            <div slot="title">
              <img src="../assets/ELMS_Logo.png" alt="ELMS Logo" class="elms-logo" />
            </div>
            <template slot="description">
              <a-form id="components-form-demo-normal-login" :form="form" class="login-form" @submit="handleSubmit">
                <a-form-item>
                  <a-input
                    v-decorator="[
                      'userName',
                      {
                        rules: [{ required: true, message: 'Please input username!' }]
                      }
                    ]"
                    placeholder="username"
                  >
                    <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
                  </a-input>
                </a-form-item>
                <a-form-item>
                  <a-input-password
                    v-decorator="[
                      'password',
                      {
                        rules: [{ required: true, message: 'Please input password!' }]
                      }
                    ]"
                    type="password"
                    placeholder="password"
                  >
                    <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
                  </a-input-password>
                </a-form-item>
                <a-form-item>
                  <a-button
                    type="primary"
                    html-type="submit"
                    class="login-form-button"
                    :disabled="signingIn"
                    :loading="signingIn"
                  >
                    Sign In
                  </a-button>
                </a-form-item>
              </a-form>
              <a-row type="flex" justify="center">
                <p style="text-align: center;">
                  Note: ELMS Web Monitor (V1.2.8) is optimized for Chrome, Safari, Firefox, and Edge (> V81.0) internet
                  browsers.
                </p>
              </a-row>
            </template>
          </a-card-meta>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";
import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
export default {
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      signingIn: false
    };
  },
  computed: {
    ...mapState(["UserPool"])
  },
  methods: {
    ...mapMutations([
      "saveIdToken",
      "saveUserName",
      "saveAccessGroups",
      "saveCognitoUser",
      "saveUserObject",
      "saveCompanyMap",
      "saveSingleCompanyUser"
    ]),

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.signingIn = true;
          this.signIn(values.userName, values.password);
        } else {
          this.$message.error("Login information error!");
        }
      });
    },

    // use the username and password to authenticate the user.
    signIn(Username, Password) {
      const authenticationDetails = new AuthenticationDetails({
        Username,
        Password
      });
      const cognitoUser = new CognitoUser({
        Username: Username,
        Pool: this.UserPool
      });
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: result => {
          // if successful, parse the result to store user's credentials and custom attributes.
          var IdToken = result.getIdToken().getJwtToken();
          var accessGroups = result.getIdToken().payload["cognito:groups"];
          this.saveAccessGroups(accessGroups);
          this.saveIdToken(IdToken);
          this.saveUserName(Username);
          // also store the IdToken in the axios header.
          axios.defaults.headers.common["Authorization"] = IdToken;
          // before directing the user to the main page, parse the authorized companies from the result, and create a user object to save in session storage.
          var authorizedCompanies = result.getIdToken().payload["custom:authorizedCompanies"];
          let companyMap = new Map();
          let safeUserObject = {};
          let companyArray = JSON.parse(authorizedCompanies);
          var singleCompanyUser = false;
          if (companyArray.length == 1) {
            singleCompanyUser = true;
          }
          // save all the necessary user attributes in a safe user object.
          safeUserObject["authorizedCompanies"] = companyArray;
          safeUserObject["singleCompanyUser"] = singleCompanyUser;
          companyArray.forEach(company => {
            companyMap.set(company.company, {
              depots: company.depot,
              region: company.region,
              hasTransformer: company.hasTransformer
            });
          });
          this.saveSingleCompanyUser(singleCompanyUser);
          this.saveUserObject(safeUserObject);
          this.saveCompanyMap(companyMap);

          // direct the user to the main page once user object is created.
          this.$router.push({ path: "Main/ChargerStatusMonitor" });
        },
        onFailure: err => {
          if (err.message == "Incorrect username or password.") {
            this.$message.error(err.message);
          } else if (err.message == "User is disabled.") {
            this.$message.error(err.message);
          } else {
            this.$message.error("Invalid login credentials. Please try again!");
          }
          this.signingIn = false;
        }
      });
      this.saveCognitoUser(cognitoUser);
    }
  }
};
</script>

<style lang="less" scoped>
#login {
  height: 100%;
  background-color: #fbfbfb;
  .login-card {
    border-radius: 15px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  .io-controls-logo {
    padding-right: 10px;
    padding-left: 10px;
    padding-top: 10px;
    max-height: 80px;
    width: 100%;
  }
  .elms-logo {
    max-height: 140px;
    width: 100%;
    height: auto;
    text-align: center;
    padding-bottom: 10px;
  }
  .ant-btn-primary {
    width: 100%;
  }
  > div {
    height: 100%;
  }
  > form {
    max-width: 600px;
  }
}
</style>
